<script setup lang="ts">
interface Props {
  imagePath: string
  watched: boolean
}
defineProps<Props>()
</script>

<template>
  <div class="story-tile" :class="{ 'story-tile_watched': watched }">
    <img class="story-tile__image" :src="imagePath" alt="история" />
  </div>
</template>

<style scoped lang="scss">
// размер задается внешним контейнером
.story-tile {
  border: 1.5px solid $primary-green;
  padding: 1.5px;
  width: 100%;
  height: 100%;
  border-radius: 10px;

  &_watched {
    border-color: $ui-gray-2;
  }

  &__image {
    max-width: 100%;
    width: 100%;
    height: 100%;
    border-radius: inherit;
  }
}
</style>
